import {
  UPDATE_CANDIDATE_FILTERS,
  CANDIDATE_LIST_REQUEST,
  CANDIDATE_LIST_SUCCESS,
  CANDIDATE_LIST_FAILURE,
  CANDIDATE_CHANGE_STATUS_REQUEST,
  CANDIDATE_CHANGE_STATUS_SUCCESS,
  CANDIDATE_CHANGE_STATUS_FAILURE,
  CANDIDATE_DETAIL_SUCCESS,
  CANDIDATE_DOCS_SUCCESS,
  CANDIDATE_RELEASE_DEVICE_REQUEST,
  CANDIDATE_RELEASE_DEVICE_SUCCESS,
  CANDIDATE_RELEASE_DEVICE_FAILURE,
  FORWARD_CANDIDATE_EMAIL_REQUEST,
  FORWARD_CANDIDATE_EMAIL_SUCCESS,
  FORWARD_CANDIDATE_EMAIL_FAILURE
} from '../../actions/candidateActions'
import { showToast } from '../../utils/toast'

const parseCandidate = data => {
  const newData = { ...data }
  newData.results = newData.results.reduce((acc, el) => {
    const element = { ...el }
    element.vehicle.message = element.message
    element.vehicle = [element.vehicle]
    element.vehicle.push(element.message)
    acc.push(element)
    return acc
  }, [])
  return newData
}

export default function reducer(
  state = {
    isFetching: false,
    data: {},
    error_change_status: [],
    errors: {},
    filters: {
      page: 1,
      search: '',
      created_at_0: null,
      created_at_1: null
    },
    candidateDetail: false,
    candidateDocs: false,
    isSuccess: false,
    activeAction: null,
    needRefresh: false,
    isReleasingDevice: false,
    releaseDeviceError: []
  },
  action
) {
  switch (action.type) {
    case CANDIDATE_CHANGE_STATUS_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        needRefresh: false,
        error_change_status: [],
        isSuccess: false
      })
    case CANDIDATE_CHANGE_STATUS_SUCCESS:
      showToast.success(
        `Estado cambiado a ${action.data.status_label} del postulante ${action.data.first_name} ${action.data.last_name}`
      )
      return Object.assign({}, state, {
        isFetching: false,
        needRefresh: true,
        isSuccess: true
      })
    case CANDIDATE_CHANGE_STATUS_FAILURE:
      showToast.error(action.errors[0])
      return Object.assign({}, state, {
        error_change_status: action.errors
      })
    case CANDIDATE_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        needRefresh: false
      })

    case CANDIDATE_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: parseCandidate(action.data)
      })

    case CANDIDATE_LIST_FAILURE:
      showToast.error(action.errors.status[0])
      return Object.assign({}, state, {
        isFetching: false,
        errors: action.data
      })
    case UPDATE_CANDIDATE_FILTERS:
      return Object.assign({}, state, {
        filters: Object.assign({}, state.filters, action.data),
        needRefresh: true
      })
    case CANDIDATE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        candidateDetail: action.data
      })

    case CANDIDATE_DOCS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        candidateDocs: action.data
      })

    case CANDIDATE_RELEASE_DEVICE_REQUEST:
      return Object.assign({}, state, {
        isReleasingDevice: true,
        releaseDeviceError: [],
        needRefresh: false
      })

    case CANDIDATE_RELEASE_DEVICE_SUCCESS:
      showToast.success('Dispositivo liberado correctamente')
      return Object.assign({}, state, {
        isReleasingDevice: false,
        needRefresh: true,
        releaseDeviceError: []
      })

    case CANDIDATE_RELEASE_DEVICE_FAILURE:
      // Mostrar el primer error del array de errores
      const errorMessage =
        action.errors && action.errors.length > 0
          ? action.errors[0]
          : 'Error al liberar dispositivo'
      showToast.error(errorMessage)
      return Object.assign({}, state, {
        isReleasingDevice: false,
        releaseDeviceError: action.errors || []
      })

    case FORWARD_CANDIDATE_EMAIL_REQUEST:
      return Object.assign({}, state, {
        isForwardingEmail: true
      })

    case FORWARD_CANDIDATE_EMAIL_SUCCESS:
      showToast.success('Email reenviado correctamente')
      return Object.assign({}, state, {
        isForwardingEmail: false
      })

    case FORWARD_CANDIDATE_EMAIL_FAILURE: {
      const emailErrorMessage =
        action.errors && action.errors.length > 0
          ? action.errors[0]
          : 'Error al reenviar el email'
      showToast.error(emailErrorMessage)
      return Object.assign({}, state, {
        isForwardingEmail: false
      })
    }

    default:
      return state
  }
}
